import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import SendIcon from '@material-ui/icons/Send';
// import clsx from 'clsx';
// import OutlinedInput from '@material-ui/core/OutlinedInput';
// import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
// import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';
// import Button from '@material-ui/core/Button';
// import Modal from '@material-ui/core/Modal';
import TextField from '@mui/material/TextField';
import Autocomplete,{createFilterOptions} from '@mui/material/Autocomplete';

let googleTransliterate = require('google-input-tool');
const chatbotLang = process.env.REACT_APP_LANG;
let placeholderVal = "Type Your Query";
if(chatbotLang === "HI"){
    placeholderVal = "अपना प्रश्न बताएं"
}

//import TextField from '@material-ui/core/TextField';
//import { NeuTextInput } from "neumorphism-react";
//import { NeuButton } from "neumorphism-react";
//import { NeuDiv } from "neumorphism-react";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
//import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
// import Visibility from '@material-ui/icons/Visibility';
// import VisibilityOff from '@material-ui/icons/VisibilityOff';
//import InputLabel from '@material-ui/core/InputLabel';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import FormHelperText from '@material-ui/core/FormHelperText';
//import IconButton from '@material-ui/core/IconButton';
//import Input from '@material-ui/core/Input';
//import FilledInput from '@material-ui/core/FilledInput';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      height: "100%",
      margin: theme.spacing(1)
    },
    appbar: {
        top: 'auto',
        bottom: 0,
        backgroundColor: grey[100],
        borderColor: grey[700],
    },
    textField: {
        width: "100%",
    },
    box:{
        top: 'auto',
        bottom: 0,
        borderColor: grey[700],
    },
    send:{
        marginTop: "5px",
        color:"#ff693a"
    },
    msgText:{
       // borderRadius: "50px !important",
      //  backgroundColor: "#FFF !important",
        //border: "1px solid #162b75",
        height:"45px",
        //color:"#162b75"
    },
    paper: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        //backgroundColor: "#F0F0F0",
        borderRadius: "0",
        borderBottom: "5px solid #ff693a"
    },

    btn: {
        margin: theme.spacing(1),
        background: "#f26522",
        color: "#fff",
    },

    modalHeader:{
        textAlign: 'center', 
        color:'#fff',
        padding: "11px",
        background: "#f26522",
        borderTopLeftRadius: "7px",
        borderTopRightRadius: "7px",
    },

     modal: {
        position: 'fixed',
        transform: "translate(-50%, -50%)",
        width: "97%", //Old value was 400px
        backgroundColor: theme.palette.background.paper,
        borderBottom: "10px solid #f26522",
        boxShadow: theme.shadows[5],
        borderRadius: "10px",
        color: '#162b75',
        opacity: "0.95",
        backgroundImage: "radial-gradient(#f265227d 0.35px, #fff 0.35px)",
        backgroundSize: "7px 7px",
        //border: "2px solid #334"
        //border: '2px solid #f26522',
        //padding: theme.spacing(2, 4, 3),
        //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        //border: '2px solid #000',
        
        //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        //color: 'white',
        //padding: theme.spacing(2, 4, 3),
    },
}));

const ChatInput = (props) => {
    const classes = useStyles();
    const queries = [
        {"que":"How to open account"},
        {"que":"How to contact branch?"},
        {"que":"Tell me about processing charges?"},
        {"que":"What is bob world wave"},
        {"que":"What is bob world"},
        {"que":"How to block atm card?"},
        {"que":"I forgot sign in password. What should I do?"},
        {"que":"How to change transaction password"},
        {"que":"What to do when account is locked"},
        {"que":"How to change login password"},
        {"que":"How to change application password"},
        {"que":"tell type of cards"},
        {"que":"tell me about corporate tax?"},
        {"que":"How to de-register from mobile banking?"},
        {"que":"From where to download forms?"},
        {"que":"How can I set pin in my card?"},
        {"que":"What is Baroda Reloadable card?"},
        {"que":"What is atal pension yojana?"},
        {"que":"What are beneifts of PPF?"},
        {"que":"Can I submit the Life Certificate to any Bank of Baroda Branch?"},
        {"que":"How can I claim family pension?"},
        {"que":"How is interest rate calculated in PPF?"},
        {"que":"How many APY accounts can be opened by one person?"},
        {"que":"How many loans can be availed against PPF?"},
        {"que":"Is family pension applicable in case of death of subscriber?"},
        {"que":"What is maximum deposit amount in case of PPF?"},
        {"que":"What is minimum deposit amount in case of PPF?"},
        {"que":"How to open PPF?"},
        {"que":"Benefits of APY?"},
        {"que":"How to transfer PPF account?"},
        {"que":"What is the process to claim Family Pension?"},
        {"que":"Who can open account under PPF Scheme?"},
        {"que":"What are the various Channels to submit Life certificate?"},
        {"que":"what is interest rate?"},
        {"que":"I want to avail education Loan."},
        {"que":"I want to avail vehicle Loan."},
        {"que":"I want to avail car Loan."},
        {"que":"I want to avail bike Loan."},
        {"que":"I want to avail personal Loan."},
        {"que":"I want to avail home Loan."},
        {"que":"I want to avail Loan against property."},
        {"que":"I want to avail Loan against jewellery."},
        {"que":"Want to avail MSME loan."},
        {"que":"Want to avail loan for skill training."},
        {"que":"Need the contact information for the Bank of Baroda."},
        {"que":"Tell me IFSC code of branch"},
        {"que":"Locate ATM"},
        {"que":"Locate branch"},
        {"que":"How to check account balance?"},
        {"que":"How to transfer account?"},
        {"que":"How to apply for atm card."},
        {"que":"Can I use mobile app for two accounts on same number?"},
        {"que":"How to deposit cash through agent?"},
        {"que":"How to withdraw cash through agent?"},
        {"que":"What are the documents required for Loan?"},
        {"que":"Tell me about education loan interest subsidy?"},
        {"que":"How much loan I will get in Auto loan ?"},
        {"que":"How much loan I will get in home loan ?"},
        {"que":"How much loan I will get in Personal loan ?"},
        {"que":"Is it mandatory to pay the interest during the study period?"},
        {"que":"What is maximum repayment period of education loan?"},
        {"que":"What is maximum repayment period of auto loan?"},
        {"que":"what is maximum repayment period for bike loan?"},
        {"que":"what is maximum repayment period for car loan?"},
        {"que":"what is maximum repayment period for personal loan?"},
        {"que":"what is maximum repayment period for home loan?"},
        {"que":"I do not have  A/c in BOB shall I be able to apply for the loan?"},
        {"que":"How to register for door step banking?"},
        {"que":"How to submit digital life certificate?"},
        {"que":"How to see transaction history?"},
        {"que":"How to transfer account?"},
        {"que":"Whether collateral is mandatory in Education Loans?"},
        {"que":"Whether simple or compound interest is charged in Education Loan?"},
        {"que":"Whether third party guarantee is mandatory for education loan?"},
        {"que":"Will Bank takeover my Education loan from other bank?"},
        {"que":"Suggest a product for me."},
        {"que":"How to register for mobile banking?"},
        {"que":"Tell me about mobile banking services?"},
        {"que":"How to connect to agent?"},
        {"que":"Tell me about auto insurance."},
        {"que":"Tell me about baroda radiance"},
        {"que":"I want to know about wealth management"},
        {"que":"Tell me details of contact centre"},
        {"que":"Which product offer unlimted cheques"},
        {"que":"Which product offers overdraft facility"}		
    ];

    
    const OPTIONS_LIMIT = 5;
    const filterOptions = createFilterOptions({
        limit: OPTIONS_LIMIT,
    });

    
    const [ isSendDisabled, setIsSendDisabled ] = useState(true);
    const [ chatInputText, setChatInputText ] = useState ("");
    const [ chatLanguage, setChatLanguage ] = useState (chatbotLang);
    const [open, setOpen] = React.useState(false); //For Modal
    const [openAutocomplete, setOpenAutocomplete] = React.useState(false); //For Modal
    const [selectedVal, setSelectedVal] = React.useState(""); //Used to send value of the text selected from autocomplete

    const [anchorEl, setAnchorEl] = React.useState(null);

    //alert(chatbotLang === "EN")

    // const handleModalOpen = () => {
    //     setOpen(true);
    // };

    const handleModalClose = () => {
        setOpen(false);
        window.parent.document.getElementById("chatIframe").src = "https://www.bankofbaroda.in/chat/bob/countrywebsite/india/build2/hi/index.html"; //Set Hindi Chatbot URL
    }; 
    //const google = window.google = window.google ? window.google : {};
    //const google = window.google;
    let inputLanguage = 'ne-t-i0-und';
    let maxResult = 8;
    let request = new XMLHttpRequest();

    
    const onInputValueChange = (event, value) => {
        //console.log(value);
        //console.log(isSendDisabled);
        //console.log(value)
        if(value !== ""){
            setIsSendDisabled(false);
        }else{
            setIsSendDisabled(true);
        }
        //console.log(isSendDisabled)
        if(chatInputText && !value){
            //console.log(isSendDisabled)
            
            setSelectedVal(chatInputText);
        }else{
            
            setSelectedVal(value);
        }
        // console.log(isSendDisabled);
        // console.log(selectedVal);
        // console.log(chatInputText)
           
    }

    const onKeyDownHandler = (event, value) => {
       
        if((chatbotLang === "HI" && chatLanguage === "HI") && (event.key === " " || event.key === 'Tab')){
            googleTransliterate(request, chatInputText, inputLanguage, maxResult)
            .then(function(response) {
                //console.log('Transliterated Text: ', response[0][0]);
                setChatInputText(response[0][0]+" ");
            });
        }
        if (event.key === 'Enter') {
           
           // console.log(document.getElementById('test').value)
            onSendClicked();            
        }
       
    }

    const onSendClicked = () => {
        // console.log("Entere key condtion")
        //console.log("inside")
        if(selectedVal !== "" && selectedVal !== null){  
            props.chatInputHandler(selectedVal);
            setChatInputText("");
            setSelectedVal("");
            setOpenAutocomplete(false); 
            setIsSendDisabled(true);
        }else if(chatInputText.trim() !== "" && chatInputText !== null){
            //console.log("Inside Else");
            //console.log(chatInputText)
           // console.log(chatInputText.length);
            props.chatInputHandler(chatInputText);
            setChatInputText("");
            setSelectedVal("");
            setOpenAutocomplete(false);            
            //setIsSendDisabled(true);
        }else{
           //console.log(chatInputText)
            setIsSendDisabled(true);
        }
        
    }


    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    const handleLangChange = (event) => {
        setAnchorEl(null);
       // console.log(event.target.dataset.lang);
        setChatLanguage(event.target.dataset.lang);
        if(event.target.dataset.lang === "HI" && chatbotLang !== "HI"){
            setOpen(true);
            document.getElementById("txtChat").placeholder = "अपना प्रश्न बताएं";            
        }

        if(event.target.dataset.lang === "EN"  && chatbotLang !== "EN"){
            document.getElementById("txtChat").placeholder = "Type your query";
            window.parent.document.getElementById("chatIframe").src = "https://www.bankofbaroda.in/chat/bob/countrywebsite/india/build2/en/index.html"; // Set English Chatbot URL
        }
        setChatInputText("");
    };

    
    return (
        <Box className={classes.box}>
            <AppBar position="fixed" className={classes.appbar}>
            {/* <NeuDiv width="100%" height="100%" radius={0} distance={1} color={grey[200]}> */}
            <Paper className={classes.paper}>
                <Box width="100%" >
                    <Grid container spacing={1} alignItems="stretch">                
                        <Grid item xs={10} sm={10} md={11} lg={11} xl={11} >
                            {/* <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined"> */}
                                {/* <OutlinedInput  
                                    className={classes.msgText} 
                                    placeholder={placeholderVal} 
                                    value={chatInputText} 
                                    onChange={onInputChange} 
                                    onKeyDown={onKeyDownHandler} 
                                    id="txtChat" 
                                    autoComplete='off' 
                                /> */}
                                  <Autocomplete
                                        autoComplete
                                        autoSelect
                                        selectOnFocus={true}
                                        id="autocompleteElem" 
                                        freeSolo
                                        disableClearable
                                        
                                        open={openAutocomplete}
                                        onOpen={() => {
                                            // only open when in focus and inputValue is not empty
                                            if (chatInputText) {
                                              setOpenAutocomplete(true);
                                            }
                                        }}
                                        onClose={(e,v) => {setOpenAutocomplete(false);
                                           // console.log(selectedVal)
                                            if (e.key === 'Enter') {
                                                //console.log("Inside IF of Close");
                                                props.chatInputHandler(selectedVal);
                                                setIsSendDisabled(true);
                                                setChatInputText("");
                                                setSelectedVal("");            
                                            }
                                           
                                        }}
                                        inputValue={chatInputText}

                                        filterOptions={filterOptions}
                                        
                                        onKeyDown={onKeyDownHandler} 
                                        
                                        onHighlightChange={onInputValueChange}
                                        value={chatInputText} 
                                        onInputChange={(e, value, reason) => {
                                            setChatInputText(value);
                                            //console.log(chatInputText);
                                            setIsSendDisabled(false);
                                            // only open when inputValue is not empty after the user typed something
                                            if (!value) {
                                              setOpenAutocomplete(false);
                                            }
                                        }}
                                        
                                        options={queries.map((option) => option.que)}
                                        
                                        renderInput={(params) => <TextField {...params} id="txtChat" sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                          }}
                                          placeholder={placeholderVal}
                                          
                                        />}
                                        
                                    />
                            {/* </FormControl>  */}
                        </Grid> 

                        {/* <Grid item xs={2} sm={2} md={2} lg={1} xl={1} justify="flex-end">
                            <KeyboardOutlinedIcon id="sel-chat-lang" fontSize="large" 
                                className={classes.send} aria-controls="lang-menu" aria-haspopup="true" onClick={handleClick}
                            />   
                            <Menu
                                id="lang-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleLangChange}
                            >
                                {chatbotLang === "HI" &&
                                    <MenuItem onClick={handleLangChange} data-lang="EN">English</MenuItem>
                                }
                                {chatbotLang === "EN" &&
                                    <MenuItem onClick={handleLangChange} data-lang="HI">Hindi</MenuItem>
                                }
                            </Menu>
                            <Modal
                                disableEscapeKeyDown
                                open={open}
                                //onClose={handleLangChange}
                                aria-labelledby="lang-modal-title"
                                aria-describedby="lang-modal-description"
                                >
                                <div style={{top:'30%', left:'50%'}} className={classes.modal}>
                                    <h4 className={classes.modalHeader} id="lang-modal-title">अस्वीकरण</h4>
                                    <h6 style={{textAlign: 'center', color:'#162b75', padding:"5px 10px"}} >
                                        पाठ आपकी भाषा में अनुवादित किया जाएगा और हो सकता है कि पुरी तरह सटीक ना हो। 
                                        अधिक स्पष्टता के लिए, कृपया हमारे फोनबैंकिंग प्रतिनिधि से संपर्क करें या अपनी निकटतम शाखा पर जाएं।
                                    </h6>
                                    <p id="lang-modal-description">
                                        <Box component="fieldset" mb={3} borderColor="transparent" style={{textAlign: 'center'}}>
                                            <Button variant="outlined" style={{ backgroundColor: '#f26522' }} size="small" 
                                                onClick={handleModalClose} className={classes.btn}>पुष्टि करें
                                            </Button>
                                        </Box>
                                    </p>
                                </div>
                            </Modal>
                        </Grid> */}

                        <Grid item xs={2} sm={2} md={1} lg={1} xl={1}/* justify="flex-end"*/>
                            <SendIcon fontSize="large" className={classes.send} 
                                disabled={isSendDisabled} onClick={onSendClicked}/>                        
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            {/* </NeuDiv> */}
            </AppBar>
        </Box>
    )    
};

export default ChatInput;